<template>
  <svg width="2em" height="2em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.3 13.65h1.4V10.7h2.95V9.3H12.7V6.325h-1.4V9.3H8.35v1.4h2.95Zm-8.6 7.075V4.4q0-.725.5-1.225.5-.5 1.2-.5h15.2q.7 0 1.2.5t.5 1.2v11.25q0 .7-.5 1.2t-1.2.5H6.125Zm1.4-3.375 1.425-1.425H19.6q.125 0 .212-.088.088-.087.088-.237V4.4q0-.15-.088-.238-.087-.087-.212-.087H4.4q-.125 0-.212.087Q4.1 4.25 4.1 4.4Zm0-12.95V4.075 17.35Z" fill="currentColor"/>
  </svg>
</template>
